$(function(){
	$('#mobAtb').click(function(){
		$('.shopify-buy__btn').first().click();
		$('#basket-toggle').click();
	})
})